export default __webpack_public_path__ + "static/media/order.9d5d9d96.svg";